import { Currency } from 'config/consts';

export const currencyToFlag = (currency: Currency): string => {
  return `/static/images/national-flag/${currency.slice(0, 2)}.svg`;
};

export const currencyToName = (currency: Currency): string => {
  switch (currency) {
    case 'USD':
      return '米ドル';
    case 'EUR':
      return 'ユーロ';
    case 'GBP':
      return '英ポンド';
    case 'AUD':
      return '豪ドル';
    case 'TRY':
      return 'トルコリラ';
    case 'ZAR':
      return 'ランド';
    case 'NZD':
      return 'NZドル';
    case 'BRL':
      return 'ブラジルレアル';
    case 'CAD':
      return 'カナダドル';
    case 'CHF':
      return 'スイスフラン';
    case 'SGD':
      return 'SGドル';
    case 'HKD':
      return '香港ドル';
    case 'CNY':
      return '中国人民元';
    case 'KRW':
      return '韓国ウォン';
    case 'THB':
      return 'タイバーツ';
    case 'MYR':
      return 'マレーシアリンギット';
    case 'IDR':
      return 'インドネシアルピア';
    case 'PHP':
      return 'フィリピンペソ';
    case 'VND':
      return 'ベトナムドン';
    case 'TWD':
      return '新台湾ドル';
    case 'MXN':
      return 'メキシコペソ';
    case 'RUB':
      return 'ロシアルーブル';
    case 'INR':
      return 'インドルピー';
    case 'SEK':
      return 'スウェーデンクローナ';
    case 'NOK':
      return 'ノルウェークローネ';
    case 'DKK':
      return 'デンマーククローネ';
    case 'PLN':
      return 'ポーランドズロチ';
  }
};
